const SELF_CERTIFICATION_DOCUMENT_TYPES = {
  INDIVIDUAL_SELF_CERTIFICATION: {
    value: "individual_self_certification",
    readableName: "Individual Self-Certification",
  },
  ENTITY_SELF_CERTIFICATION: {
    value: "entity_self_certification",
    readableName: "Entity Self-Certification",
  },
};

export const selfCertificationDocumentTypesArray = Object.values(
  SELF_CERTIFICATION_DOCUMENT_TYPES,
);
